export const BADGE_COLOR_MAPPING = {
  2: {
    color: 'success',
    text: 'dashboard.http_status.ok',
  },
  4: {
    color: 'warning',
    text: 'dashboard.http_status.error',
  },
  5: {
    color: 'critical',
    text: 'dashboard.http_status.error',
  },
}

export const ELMO_EXPERIMENTS = {
  UpgradeHub: {
    Treatment: 'Trmt_developer_upgrade_hub_v2',
  },
  DevdashPartnerSetupSelfServeElmoEligibility: {
    Treatment: 'Trmt_enable_devdash_partner_setup_selfserve',
  },
}
export const NEW_USER = 'newuser'
export const EXISTING_USER = 'existinguser'

export const PERSISTENT_NAV_WIDTH = '240px'
export const FALLBACK_HEADER_DATA = {} // TODO - Add fallback header params to ensure that flows work okay even in case of error.
export const MINIMUM_DESKTOP_WIDTH = 1024
export const HEADER_HEIGHT = '72px'
export const HEADER_MOBILE_HEIGHT = '62px'
